export default {
  dashboard: "Dashboard",
  users: "Nutzer",
  areaIncomeRange: "Einkommensbereich",
  clients: "Kunden",
  invoices: "Rechnungen",
};
